var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleButtonover2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Circle_Button_over",
    "data-name": "Circle Button over",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #bbe36c;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: rgba(253,73,198,0.35);\r\n        opacity: 0;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #2f2f2f;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-1",
    width: 48,
    height: 48,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ICON_feather_linkedin_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Icon [ICON=feather/linkedin][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_ICON:feather_linkedin_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [ICON:feather/linkedin][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-2",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.667 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ff1063f9-2c20-47f8-ac85-615e9b8649a4",
    className: "cls-3",
    d: "M16,7a7.008,7.008,0,0,1,7,7v7a1,1,0,0,1-1,1H18a1,1,0,0,1-1-1V14a1,1,0,0,0-2,0v7a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V14A7.008,7.008,0,0,1,16,7Zm5,13V14a5,5,0,0,0-10,0v6h2V14a3,3,0,0,1,6,0v6Z",
    transform: "translate(-3.667 -3.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_91e912f9-4d94-4e55-b2fe-f3f4ed8929ee",
    "data-name": "91e912f9-4d94-4e55-b2fe-f3f4ed8929ee",
    className: "cls-3",
    d: "M0-1H4A1,1,0,0,1,5,0V12a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM3,1H1V11H3Z",
    transform: "translate(-1.667 5.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a22b7da1-2b0e-4771-a21c-56f1d0940f7a",
    className: "cls-3",
    d: "M2-1A3,3,0,1,1-1,2,3,3,0,0,1,2-1ZM2,3A1,1,0,1,0,1,2,1,1,0,0,0,2,3Z",
    transform: "translate(-1.667 -1.167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleButtonover2);
export default __webpack_public_path__ + "static/media/Circle Button over-2.efcc6c28264a8518ffee05cd7f35cf98.svg";
export { ForwardRef as ReactComponent };